export type NewsLangBlock = {
  title: string;
  summary: string;
  content: string;
};

export type NewsItem = {
  id: string;
  slug: string;
  category: 'gold' | 'markets' | 'rates' | 'central-bank' | 'logistics';
  source: string;
  sourceUrl?: string;
  publishedAt: string; // ISO string
  image?: string;
  tags: string[];
  lang: {
    'zh-HK': NewsLangBlock;
    'zh-CN': NewsLangBlock;
    en: NewsLangBlock;
  };
};

export const goldNews: NewsItem[] = [
  {
    id: 'gold-2026-07-22-two-week-high',
    slug: 'gold-two-week-high-july-22-2026',
    category: 'gold',
    source: 'Reuters',
    sourceUrl: 'https://www.reuters.com/world/india/gold-nears-two-week-high-fed-outlook-middle-east-conflict-stay-focus-2026-07-22/',
    publishedAt: '2026-07-22T10:10:00Z',
    image: '/img/news/gold-01.jpg',
    tags: ['Gold', 'Federal Reserve', 'Dollar'],
    lang: {
      'zh-HK': {
        title: '美元回軟推動金價升至兩周高位，市場聚焦聯儲局會議',
        summary: '美元轉弱配合技術買盤，帶動現貨金在 7 月 22 日升至兩星期高位，白銀亦同步上升。',
        content: '金價在亞洲及歐美交易時段走強，市場一方面吸納避險資產，另一方面等待聯儲局 7 月 28 至 29 日會議提供新的利率線索。短線走勢仍可能受到油價、美元及美債孳息變化影響。',
      },
      'zh-CN': {
        title: '美元走软推动金价升至两周高位，市场聚焦美联储会议',
        summary: '美元转弱配合技术买盘，推动现货黄金在 7 月 22 日升至两周高位，白银也同步上涨。',
        content: '金价在亚洲及欧美交易时段走强，市场一方面吸纳避险资产，另一方面等待美联储 7 月 28 至 29 日会议提供新的利率线索。短线走势仍可能受到油价、美元及美债收益率变化影响。',
      },
      en: {
        title: 'Gold reaches a two-week high as the dollar softens ahead of the Fed meeting',
        summary: 'A weaker dollar and renewed technical buying lifted spot gold to a two-week high on July 22, with silver also advancing.',
        content: 'Bullion strengthened across Asian, European and U.S. trading as investors balanced safe-haven demand against the interest-rate outlook. Attention now turns to the Federal Reserve meeting on July 28–29, while oil, the dollar and Treasury yields remain key near-term drivers.',
      },
    },
  },
  {
    id: 'gold-2026-07-21-diplomacy-rally',
    slug: 'gold-diplomacy-rally-july-21-2026',
    category: 'markets',
    source: 'Reuters',
    sourceUrl: 'https://www.reuters.com/world/india/gold-rises-hopes-us-iran-diplomacy-pause-oil-rally-2026-07-21/',
    publishedAt: '2026-07-21T10:25:00Z',
    image: '/img/news/gold-02.jpg',
    tags: ['Gold', 'Silver', 'Geopolitics'],
    lang: {
      'zh-HK': {
        title: '中東外交憧憬帶動貴金屬反彈，白銀升幅較金價明顯',
        summary: '市場憧憬中東局勢出現短暫外交緩和，商品市場回升，金價及白銀同步反彈。',
        content: '地緣政治風險仍然偏高，但任何停火或談判消息都可能同時影響油價、通脹預期及利率押注。當日金價受商品市場整體回升及技術突破支持，白銀因波動性較高而錄得更大升幅。',
      },
      'zh-CN': {
        title: '中东外交预期推动贵金属反弹，白银涨幅较黄金明显',
        summary: '市场憧憬中东局势出现短暂外交缓和，商品市场回升，黄金及白银同步反弹。',
        content: '地缘政治风险仍然偏高，但任何停火或谈判消息都可能同时影响油价、通胀预期及利率押注。当日金价受到商品市场整体回升及技术突破支持，白银因波动性较高而录得更大涨幅。',
      },
      en: {
        title: 'Gold and silver rebound as diplomatic hopes improve commodity sentiment',
        summary: 'Prospects of a temporary diplomatic pause in Middle East tensions supported a broad commodity rebound, lifting both gold and silver.',
        content: 'Geopolitical risk remains elevated, but any ceasefire or negotiation signal can quickly reshape oil prices, inflation expectations and rate bets. Gold benefited from the broader commodity move and a technical breakout, while higher-beta silver posted a larger gain.',
      },
    },
  },
  {
    id: 'gold-2026-07-20-oil-rate-pressure',
    slug: 'gold-oil-rate-pressure-july-20-2026',
    category: 'rates',
    source: 'Reuters',
    sourceUrl: 'https://www.reuters.com/world/india/gold-slips-oil-prices-advance-fed-rate-hike-voices-grow-2026-07-20/',
    publishedAt: '2026-07-20T10:15:00Z',
    image: '/img/news/gold-08.jpg',
    tags: ['Gold', 'Oil', 'Interest Rates'],
    lang: {
      'zh-HK': {
        title: '油價上升重燃通脹及加息憂慮，金價輕微受壓',
        summary: '能源價格上升令市場重新評估通脹風險及聯儲局政策路徑，無息資產黃金受到一定壓力。',
        content: '金價在 7 月 20 日窄幅偏軟。雖然地緣風險通常支持避險需求，但油價上升亦會推高通脹預期，令市場押注利率維持高位甚至再次上調，削弱持有黃金的相對吸引力。',
      },
      'zh-CN': {
        title: '油价上涨重燃通胀及加息忧虑，金价小幅承压',
        summary: '能源价格上涨令市场重新评估通胀风险及美联储政策路径，无息资产黄金受到一定压力。',
        content: '金价在 7 月 20 日窄幅偏弱。虽然地缘风险通常支持避险需求，但油价上涨也会推高通胀预期，令市场押注利率维持高位甚至再次上调，削弱持有黄金的相对吸引力。',
      },
      en: {
        title: 'Gold edges lower as rising oil prices revive inflation and rate concerns',
        summary: 'Higher energy prices prompted investors to reassess inflation risks and the Federal Reserve path, weighing on non-yielding bullion.',
        content: 'Gold traded slightly lower on July 20. Geopolitical stress can support safe-haven demand, but a parallel rise in oil can lift inflation expectations and strengthen the case for rates to remain high or rise again, reducing the relative appeal of holding bullion.',
      },
    },
  },
  {
    id: 'gold-2026-07-17-weekly-loss',
    slug: 'gold-weekly-loss-july-17-2026',
    category: 'gold',
    source: 'Reuters',
    sourceUrl: 'https://www.reuters.com/world/india/gold-track-biggest-weekly-loss-six-iran-war-fans-inflation-worries-2026-07-17/',
    publishedAt: '2026-07-17T11:00:00Z',
    image: '/img/news/gold-06.jpg',
    tags: ['Gold', 'Inflation', 'Weekly Market'],
    lang: {
      'zh-HK': {
        title: '金價單日反彈，但全周仍受通脹與高利率憂慮拖累',
        summary: '金價在周五回升，但全周仍錄得下跌，美元走強及能源價格上升令利率前景更偏鷹。',
        content: '市場同時消化避險需求與高息環境兩股相反力量。地緣局勢支持黃金，但油價推高通脹預期，美元及利率上升又增加持有無息資產的機會成本，令金價全周表現受壓。',
      },
      'zh-CN': {
        title: '金价单日反弹，但全周仍受通胀与高利率忧虑拖累',
        summary: '金价在周五回升，但全周仍录得下跌，美元走强及能源价格上涨令利率前景更偏鹰。',
        content: '市场同时消化避险需求与高利率环境两股相反力量。地缘局势支持黄金，但油价推高通胀预期，美元及利率上涨又增加持有无息资产的机会成本，令金价全周表现承压。',
      },
      en: {
        title: 'Gold rebounds on the day but remains lower for the week on inflation fears',
        summary: 'Friday gains were not enough to erase the weekly decline as a firmer dollar and rising energy prices kept the rate outlook hawkish.',
        content: 'The market continued to balance two opposing forces: geopolitical safe-haven demand and the drag from higher-for-longer interest rates. Rising oil lifted inflation expectations, while a stronger dollar and higher yields raised the opportunity cost of holding non-yielding bullion.',
      },
    },
  },
  {
    id: 'gold-2026-07-13-sharp-fall',
    slug: 'gold-sharp-fall-july-13-2026',
    category: 'markets',
    source: 'Reuters',
    sourceUrl: 'https://www.reuters.com/world/india/gold-slides-over-1-oil-surges-strait-hormuz-closure-fears-2026-07-13/',
    publishedAt: '2026-07-13T10:40:00Z',
    image: '/img/news/gold-09.jpg',
    tags: ['Gold', 'Volatility', 'Middle East'],
    lang: {
      'zh-HK': {
        title: '油價急升推高加息預期，金價一度下跌約 3%',
        summary: '中東緊張局勢推高能源價格，但通脹及加息憂慮反而壓過黃金的傳統避險需求。',
        content: '金價於 7 月 13 日大幅波動。市場擔心能源供應受阻令通脹再次升溫，並推動聯儲局採取更強硬政策。這種情況顯示，地緣風險不一定只會推高黃金，當利率預期同步急升時亦可能造成沽壓。',
      },
      'zh-CN': {
        title: '油价急升推高加息预期，金价一度下跌约 3%',
        summary: '中东紧张局势推高能源价格，但通胀及加息忧虑反而压过黄金的传统避险需求。',
        content: '金价于 7 月 13 日大幅波动。市场担心能源供应受阻令通胀再次升温，并推动美联储采取更强硬政策。这种情况显示，地缘风险不一定只会推高黄金，当利率预期同步急升时也可能造成抛压。',
      },
      en: {
        title: 'Gold drops about 3% as an oil surge strengthens rate-hike expectations',
        summary: 'Middle East tensions lifted energy prices, but inflation and rate concerns outweighed bullion’s traditional safe-haven appeal.',
        content: 'Gold experienced a sharp move on July 13 as investors feared that disrupted energy supplies could reignite inflation and force a more aggressive Federal Reserve response. The session showed that geopolitical stress does not always lift bullion when rate expectations rise at the same time.',
      },
    },
  },
  {
    id: 'gold-2026-07-08-forecast-reset',
    slug: 'gold-forecast-reset-july-08-2026',
    category: 'rates',
    source: 'Reuters',
    sourceUrl: 'https://www.reuters.com/world/india/gold-eases-fresh-us-iran-tensions-lift-oil-prices-rate-hike-bets-2026-07-08/',
    publishedAt: '2026-07-08T10:10:00Z',
    image: '/img/news/gold-14.jpg',
    tags: ['Gold Forecast', 'Federal Reserve', 'Banks'],
    lang: {
      'zh-HK': {
        title: '加息預期升溫，大行下調 2026 年平均金價預測但維持長線看升',
        summary: '部分大行因聯儲局取態轉鷹而調低短期金價預測，但認為緊縮周期結束後金價仍有上升空間。',
        content: '市場預測不是保證，但可反映機構如何重新評估美元、利率及通脹。今次調整顯示短期高息環境可能壓制黃金估值，同時央行需求、資產配置分散及地緣風險仍然支持較長線的需求。',
      },
      'zh-CN': {
        title: '加息预期升温，大行下调 2026 年平均金价预测但维持长期看涨',
        summary: '部分大行因美联储取态转鹰而调低短期金价预测，但认为紧缩周期结束后金价仍有上涨空间。',
        content: '市场预测不是保证，但可以反映机构如何重新评估美元、利率及通胀。本次调整显示短期高利率环境可能压制黄金估值，同时央行需求、资产配置分散及地缘风险仍然支持较长期需求。',
      },
      en: {
        title: 'Banks trim 2026 gold forecasts as rate expectations turn more hawkish',
        summary: 'Some banks lowered near-term average gold forecasts as the Federal Reserve outlook became more hawkish, while retaining a constructive longer-term view.',
        content: 'Forecasts are not guarantees, but they show how institutions are reassessing the dollar, rates and inflation. The revisions suggest that a high-rate environment can cap near-term valuations, while central-bank demand, portfolio diversification and geopolitical risk continue to support longer-term bullion demand.',
      },
    },
  },
  {
    id: 'gold-2026-04-08-safe-haven-demand',
    slug: 'gold-safe-haven-demand-april-08',
    category: 'gold',
    source: 'Reuters',
    publishedAt: '2026-04-08T12:00:00Z',
    image: '/img/news/gold-01.jpg',
    tags: ['Gold', 'Safe Haven', 'Dollar'],
    lang: {
      'zh-HK': {
        title: '避險情緒回升，金價重上高位區間',
        summary:
          '市場重新吸納避險資產，帶動金價在本周初段再度走強，美元走勢與利率預期仍是焦點。',
        content:
          '投資者因宏觀不確定性與地緣風險升溫而增持黃金，現貨金在亞洲時段表現穩健。分析認為，只要美元未有持續大幅轉強，加上市場仍保留年內減息預期，黃金短線仍可獲買盤支持。',
      },
      'zh-CN': {
        title: '避险情绪回升，金价重返高位区间',
        summary:
          '市场重新吸纳避险资产，带动金价在本周初段再度走强，美元走势与利率预期仍是焦点。',
        content:
          '投资者因宏观不确定性与地缘风险升温而增持黄金，现货金在亚洲时段表现稳健。分析认为，只要美元未有持续大幅走强，加上市场仍保留年内降息预期，黄金短线仍可获得买盘支持。',
      },
      en: {
        title: 'Gold climbs back toward recent highs on renewed safe-haven demand',
        summary:
          'Fresh demand for defensive assets helped gold strengthen at the start of the week, with traders still focused on the dollar and interest-rate expectations.',
        content:
          'Investors added to bullion positions as geopolitical and macro uncertainty supported safe-haven flows. Analysts said gold could remain supported in the near term as long as the dollar does not strengthen sharply and expectations for rate cuts later in the year stay alive.',
      },
    },
  },
  {
    id: 'gold-2026-04-07-dollar-pullback',
    slug: 'gold-dollar-pullback-april-07',
    category: 'markets',
    source: 'Reuters',
    publishedAt: '2026-04-07T12:00:00Z',
    image: '/img/news/gold-02.jpg',
    tags: ['Gold', 'Dollar', 'Markets'],
    lang: {
      'zh-HK': {
        title: '美元回調支撐金價，市場觀望美國數據',
        summary:
          '美元自高位略為回落，令金價出現反彈，投資者繼續等待更多美國經濟數據判斷利率走向。',
        content:
          '金市本周受到匯率與利率預期雙重影響。分析指出，若美國數據偏弱，市場對減息的押注可能再度增加，從而利好黃金；相反，若數據強勁，則可能限制金價上升空間。',
      },
      'zh-CN': {
        title: '美元回调支撑金价，市场观望美国数据',
        summary:
          '美元自高位略为回落，令金价出现反弹，投资者继续等待更多美国经济数据判断利率走向。',
        content:
          '金市本周受到汇率与利率预期双重影响。分析指出，若美国数据偏弱，市场对降息的押注可能再度增加，从而利好黄金；相反，若数据强劲，则可能限制金价上升空间。',
      },
      en: {
        title: 'Gold supported by softer dollar as traders await U.S. data',
        summary:
          'A pullback in the dollar helped gold recover, while investors looked to incoming U.S. data for clues on the path of rates.',
        content:
          'Bullion drew support from a softer greenback, but sentiment remained sensitive to macro releases. Analysts said weaker data could revive expectations for policy easing, while stronger numbers might cap gains in gold.',
      },
    },
  },
  {
    id: 'gold-2026-04-06-central-bank-buying',
    slug: 'gold-central-bank-buying-april-06',
    category: 'central-bank',
    source: 'Reuters',
    publishedAt: '2026-04-06T12:00:00Z',
    image: '/img/news/gold-03.jpg',
    tags: ['Central Bank', 'Reserves', 'Gold'],
    lang: {
      'zh-HK': {
        title: '央行買盤預期支撐金市，官方儲備動向受關注',
        summary:
          '市場繼續關注各國央行增持黃金的潛力，認為官方需求仍是中長線的重要支持因素。',
        content:
          '在全球資產配置多元化趨勢下，央行黃金儲備被視為提升資產安全性的工具。分析認為，即使短期價格波動較大，只要官方部門買盤保持活躍，金價中線基調仍然偏穩。',
      },
      'zh-CN': {
        title: '央行买盘预期支撑金市，官方储备动向受关注',
        summary:
          '市场继续关注各国央行增持黄金的潜力，认为官方需求仍是中长线的重要支持因素。',
        content:
          '在全球资产配置多元化趋势下，央行黄金储备被视为提升资产安全性的工具。分析认为，即使短期价格波动较大，只要官方部门买盘保持活跃，金价中线基调仍然偏稳。',
      },
      en: {
        title: 'Central-bank buying expectations continue to underpin gold',
        summary:
          'Traders remained focused on official-sector demand, which is still seen as a key medium-term pillar for the bullion market.',
        content:
          'As reserve managers diversify assets, gold continues to be viewed as a strategic holding. Analysts said that even if short-term volatility remains elevated, steady official demand could help keep the medium-term outlook for bullion constructive.',
      },
    },
  },
  {
    id: 'gold-2026-04-05-asia-physical-demand',
    slug: 'asia-physical-demand-april-05',
    category: 'logistics',
    source: 'Reuters',
    publishedAt: '2026-04-05T12:00:00Z',
    image: '/img/news/gold-04.jpg',
    tags: ['Asia', 'Physical Gold', 'Logistics'],
    lang: {
      'zh-HK': {
        title: '亞洲實金需求回穩，交易與物流活動同步改善',
        summary:
          '隨着區內補貨需求回升，亞洲實金市場交投改善，保管與物流配套亦見更穩定。',
        content:
          '市場人士指出，亞洲部分地區的買盤在價格回調後重新出現，令實金溢價與交收活動有所回暖。這反映除投資需求外，實體市場對金價同樣有一定支持作用。',
      },
      'zh-CN': {
        title: '亚洲实金需求回稳，交易与物流活动同步改善',
        summary:
          '随着区内补货需求回升，亚洲实金市场交投改善，保管与物流配套亦见更稳定。',
        content:
          '市场人士指出，亚洲部分地区的买盘在价格回调后重新出现，令实金溢价与交收活动有所回暖。这反映除投资需求外，实体市场对金价同样有一定支持作用。',
      },
      en: {
        title: 'Asian physical gold demand steadies as trade and logistics improve',
        summary:
          'Physical demand in parts of Asia showed signs of improvement, supported by restocking interest and more stable logistics conditions.',
        content:
          'Market participants said buying interest returned in some regional hubs after earlier price pullbacks, helping physical premiums and settlement activity recover. The move suggested that underlying demand from the physical market remains an important support factor for gold.',
      },
    },
  },
  {
    id: 'gold-2026-04-01-softer-dollar-rebound',
    slug: 'gold-softer-dollar-rebound-april-01',
    category: 'gold',
    source: 'Reuters',
    publishedAt: '2026-04-01T12:00:00Z',
    image: '/img/news/gold-05.jpg',
    tags: ['Gold', 'Dollar', 'Safe Haven'],
    lang: {
      'zh-HK': {
        title: '美元回軟帶動金價連升四日，市場續觀望中東局勢',
        summary:
          '金價於 4 月初連續第四個交易日上升，主要受美元回落帶動，投資者同時關注中東局勢會否降溫。',
        content:
          '現貨金在 4 月 1 日升至近期高位，市場認為美元走弱提升了黃金對非美元持有者的吸引力。分析亦指出，若地緣局勢緩和並令油價及通脹壓力回落，市場對聯儲局減息的預期有機會重新升溫，對金價形成支持。',
      },
      'zh-CN': {
        title: '美元走软带动金价连涨四日，市场继续关注中东局势',
        summary:
          '金价在 4 月初连续第四个交易日上涨，主要受美元回落推动，投资者同时关注中东局势是否降温。',
        content:
          '现货金在 4 月 1 日升至近期高位，市场认为美元走弱提升了黄金对非美元持有者的吸引力。分析也指出，若地缘局势缓和并令油价及通胀压力回落，市场对美联储降息的预期有机会重新升温，从而支持金价。',
      },
      en: {
        title: 'Gold rebounds as softer dollar supports fourth straight daily gain',
        summary:
          'Gold extended gains at the start of April as a weaker U.S. dollar improved bullion’s appeal, while investors kept a close eye on Middle East developments.',
        content:
          'Spot gold climbed for a fourth consecutive session on April 1, helped by a softer dollar and hopes that easing geopolitical tension could revive expectations for Fed rate cuts later in 2026. Analysts noted that lower oil and inflation pressure would be a constructive backdrop for bullion.',
      },
    },
  },
  {
    id: 'gold-2026-03-31-worst-month-since-2008',
    slug: 'gold-worst-month-since-2008-march-31',
    category: 'markets',
    source: 'Reuters',
    publishedAt: '2026-03-31T12:00:00Z',
    image: '/img/news/gold-06.jpg',
    tags: ['Gold', 'Monthly Move', 'Rates'],
    lang: {
      'zh-HK': {
        title: '金價月底反彈，但 3 月仍錄 2008 年以來最差單月表現',
        summary:
          '雖然金價在月尾回升，但整體 3 月仍大幅下跌，主要受高通脹憂慮及高利率預期拖累。',
        content:
          '市場在 3 月底重新評估通脹及利率走勢，高油價令通脹壓力升溫，投資者因而降低對短期減息的押注。即使月底出現技術性反彈，金價全月仍錄得顯著跌幅，反映高利率環境對無息資產的壓力仍然存在。',
      },
      'zh-CN': {
        title: '金价月底反弹，但 3 月仍录得 2008 年以来最差单月表现',
        summary:
          '虽然金价在月末回升，但整体 3 月仍大幅下跌，主要受高通胀忧虑及高利率预期拖累。',
        content:
          '市场在 3 月底重新评估通胀及利率走势，高油价令通胀压力升温，投资者因此降低对短期降息的押注。即使月底出现技术性反弹，金价全月仍录得显著跌幅，反映高利率环境对无息资产的压力仍然存在。',
      },
      en: {
        title: 'Gold ends March with its worst monthly slide since 2008 despite late rebound',
        summary:
          'Bullion recovered near month-end, but March still marked its steepest monthly decline since October 2008 as inflation fears and high-rate expectations dominated trading.',
        content:
          'Gold bounced on March 31, yet persistent inflation concerns and the prospect of rates staying higher for longer kept the metal under pressure throughout the month. The move underscored how sensitive bullion remains to interest-rate expectations even when safe-haven demand is present.',
      },
    },
  },
  {
    id: 'gold-2026-03-30-germany-silver-coins',
    slug: 'germany-cuts-silver-content-march-30',
    category: 'markets',
    source: 'Reuters',
    publishedAt: '2026-03-30T12:00:00Z',
    image: '/img/news/gold-07.jpg',
    tags: ['Silver', 'Germany', 'Collector Coins'],
    lang: {
      'zh-HK': {
        title: '德國削減部分紀念幣含銀量，反映白銀價格波動加劇',
        summary:
          '德國政府表示，因銀價大幅波動，將下調部分紀念幣的含銀比例，以減少投機及控制發行成本。',
        content:
          '白銀近年兼具貴金屬與工業金屬屬性，價格波動加大。德國最新調整顯示，貴金屬價格不僅影響投資市場，也會影響官方紀念幣與實體產品的設計及成本安排。',
      },
      'zh-CN': {
        title: '德国削减部分纪念币含银量，反映白银价格波动加剧',
        summary:
          '德国政府表示，因银价大幅波动，将下调部分纪念币的含银比例，以减少投机及控制发行成本。',
        content:
          '白银近年兼具贵金属与工业金属性，价格波动加大。德国最新调整显示，贵金属价格不仅影响投资市场，也会影响官方纪念币与实体产品的设计及成本安排。',
      },
      en: {
        title: 'Germany cuts silver content in collector coins as price swings intensify',
        summary:
          'Germany said it would reduce the silver content of some commemorative euro coins as volatile silver prices raise budget and speculation concerns.',
        content:
          'The decision highlights how recent volatility in silver is affecting not only investors but also the design and economics of official mint products. It also underscores silver’s dual role as both a precious and industrial metal.',
      },
    },
  },
  {
    id: 'gold-2026-03-27-singapore-gold-hub',
    slug: 'singapore-asia-gold-hub-march-27',
    category: 'logistics',
    source: 'Reuters',
    publishedAt: '2026-03-27T12:00:00Z',
    image: '/img/news/gold-08.jpg',
    tags: ['Singapore', 'Bullion Hub', 'Logistics'],
    lang: {
      'zh-HK': {
        title: '新加坡推進亞洲黃金交易中心定位，強化清算與倉儲配套',
        summary:
          '新加坡公布新計劃，希望加強黃金交易、清算、交收及倉儲基建，吸引更多區內黃金流轉業務。',
        content:
          '新加坡金融管理局與行業組織提出多項方向，包括擴展黃金資本市場產品、建立更可信的清算交收體系，以及提升保管和物流標準。消息反映亞洲金融中心正積極競逐實金及相關高增值業務。',
      },
      'zh-CN': {
        title: '新加坡推进亚洲黄金交易中心定位，强化清算与仓储配套',
        summary:
          '新加坡公布新计划，希望加强黄金交易、清算、交收及仓储基建，吸引更多区内黄金流转业务。',
        content:
          '新加坡金融管理局与行业组织提出多项方向，包括扩展黄金资本市场产品、建立更可信的清算交收体系，以及提升保管和物流标准。消息反映亚洲金融中心正积极竞逐实金及相关高增值业务。',
      },
      en: {
        title: 'Singapore outlines plan to build a stronger Asian gold trading hub',
        summary:
          'Singapore set out measures to improve bullion trading, clearing, settlement and vaulting in a bid to attract more regional gold flows.',
        content:
          'Authorities and industry participants in Singapore said they want to deepen the city-state’s gold ecosystem by broadening product offerings, strengthening infrastructure and improving logistics standards. The development highlights intensifying competition among Asian financial centres for bullion business.',
      },
    },
  },
  {
    id: 'gold-2026-03-19-seventh-day-losses',
    slug: 'gold-seventh-day-losses-march-19',
    category: 'rates',
    source: 'Reuters',
    publishedAt: '2026-03-19T12:00:00Z',
    image: '/img/news/gold-09.jpg',
    tags: ['Gold', 'Rates', 'Inflation'],
    lang: {
      'zh-HK': {
        title: '金價連跌七日，通脹與高利率預期壓抑買盤',
        summary:
          '金價在 3 月中旬連續第七個交易日下跌，市場擔心能源價格上升會推高通脹，令主要央行維持偏緊政策。',
        content:
          '分析指出，中東衝突帶動油價上揚，投資者因而調整對利率前景的看法。由於黃金本身不產生利息，在借貸成本維持高位時，金價通常較難維持強勢。',
      },
      'zh-CN': {
        title: '金价连跌七日，通胀与高利率预期压制买盘',
        summary:
          '金价在 3 月中旬连续第七个交易日下跌，市场担心能源价格上升会推高通胀，令主要央行维持偏紧政策。',
        content:
          '分析指出，中东冲突带动油价上扬，投资者因此调整对利率前景的看法。由于黄金本身不产生利息，在借贷成本维持高位时，金价通常较难维持强势。',
      },
      en: {
        title: 'Gold posts seventh straight daily decline as inflation worries weigh',
        summary:
          'Bullion extended losses in mid-March as rising energy prices fueled inflation fears and reinforced expectations for tighter monetary policy.',
        content:
          'The market repriced the outlook for central-bank easing as higher oil prices pushed inflation concerns back to the forefront. That environment reduced support for non-yielding assets such as gold.',
      },
    },
  },
  {
    id: 'gold-2026-03-18-fed-one-month-low',
    slug: 'gold-fed-one-month-low-march-18',
    category: 'central-bank',
    source: 'Reuters',
    publishedAt: '2026-03-18T12:00:00Z',
    image: '/img/news/gold-10.jpg',
    tags: ['Fed', 'Dollar', 'Gold'],
    lang: {
      'zh-HK': {
        title: '聯儲局按兵不動後，金價跌至逾一個月低位',
        summary:
          '聯儲局維持利率不變後，美元轉強，加上市場預期利率或高企更久，拖累金價受壓。',
        content:
          '聯儲局會後聲明及經濟預測令市場認為短期內減息空間有限，黃金隨即失守部分重要心理關口。雖然地緣風險仍在，但高利率與強美元在短線主導了金價走勢。',
      },
      'zh-CN': {
        title: '美联储按兵不动后，金价跌至逾一个月低位',
        summary:
          '美联储维持利率不变后，美元走强，加上市场预期利率或高位维持更久，拖累金价承压。',
        content:
          '美联储会后声明及经济预测令市场认为短期内降息空间有限，黄金随即失守部分重要心理关口。虽然地缘风险仍在，但高利率与强美元在短线主导了金价走势。',
      },
      en: {
        title: 'Gold falls to more than one-month low after Fed holds rates',
        summary:
          'Gold weakened after the Federal Reserve left rates unchanged, while a firmer dollar and higher-for-longer expectations pressured bullion.',
        content:
          'Markets interpreted the Fed’s message as offering limited near-term scope for rate cuts. Even with geopolitical tension still in the background, higher real-rate expectations and a stronger dollar drove the short-term move in gold.',
      },
    },
  },
  {
    id: 'gold-2026-03-18-fed-middle-east',
    slug: 'gold-fed-middle-east-march-18',
    category: 'gold',
    source: 'Reuters',
    publishedAt: '2026-03-18T12:00:00Z',
    image: '/img/news/gold-11.jpg',
    tags: ['Gold', 'Fed', 'Geopolitics'],
    lang: {
      'zh-HK': {
        title: '金價在聯儲局議息前偏軟，市場權衡中東風險',
        summary:
          '金價於聯儲局公布政策前小幅回落，投資者同時關注中東局勢升溫及高油價對通脹預期的影響。',
        content:
          '現貨金在聯儲局政策決定前輕微下跌，市場觀望氣氛濃厚。分析認為，地緣政治風險仍然支持避險需求，但若高油價推升通脹，亦可能令利率維持高位更久，對金價構成壓力。',
      },
      'zh-CN': {
        title: '金价在美联储议息前偏软，市场权衡中东风险',
        summary:
          '金价在美联储公布政策前小幅回落，投资者同时关注中东局势升温及高油价对通胀预期的影响。',
        content:
          '现货金在美联储政策决定前轻微下跌，市场观望气氛浓厚。分析认为，地缘政治风险仍支撑避险需求，但若高油价推升通胀，也可能令利率维持高位更久，从而对金价构成压力。',
      },
      en: {
        title: 'Gold eases ahead of Fed decision as markets weigh Middle East risks',
        summary:
          'Gold edged lower before the Federal Reserve decision as investors balanced geopolitical tension with inflation concerns tied to higher oil prices.',
        content:
          'Spot gold softened ahead of the Fed announcement as markets stayed cautious. Analysts said geopolitical stress continues to support safe-haven demand, but persistent inflation pressure could keep rates higher for longer and cap upside for bullion.',
      },
    },
  },
  {
    id: 'gold-2026-03-17-steady-fed-watch',
    slug: 'gold-steady-fed-watch-march-17',
    category: 'gold',
    source: 'Reuters',
    publishedAt: '2026-03-17T12:00:00Z',
    image: '/img/news/gold-12.jpg',
    tags: ['Gold', 'Fed', 'Safe Haven'],
    lang: {
      'zh-HK': {
        title: '金價持穩，市場聚焦聯儲局議息結果',
        summary:
          '投資者一邊評估地緣政治風險，一邊等待聯儲局利率決定，令金價維持窄幅波動。',
        content:
          '市場普遍預期聯儲局維持利率不變。金價在避險買盤與高利率預期之間拉鋸，短線走勢反映市場正在重新平衡通脹、油價與政策路徑的影響。',
      },
      'zh-CN': {
        title: '金价持稳，市场聚焦美联储议息结果',
        summary:
          '投资者一边评估地缘政治风险，一边等待美联储利率决定，令金价维持窄幅波动。',
        content:
          '市场普遍预期美联储维持利率不变。金价在避险买盘与高利率预期之间拉锯，短线走势反映市场正在重新平衡通胀、油价与政策路径的影响。',
      },
      en: {
        title: 'Gold holds steady as investors await Fed outcome',
        summary:
          'Bullion traded in a narrow range as markets balanced safe-haven demand against expectations for steady U.S. interest rates.',
        content:
          'With the Fed expected to hold rates, gold moved sideways as investors assessed geopolitical risks, inflation pressure and the broader path of monetary policy.',
      },
    },
  },
  {
    id: 'gold-2026-03-16-inflation-dollar',
    slug: 'gold-inflation-dollar-march-16',
    category: 'markets',
    source: 'Reuters',
    publishedAt: '2026-03-16T12:00:00Z',
    image: '/img/news/gold-13.jpg',
    tags: ['Inflation', 'Dollar', 'Gold'],
    lang: {
      'zh-HK': {
        title: '通脹憂慮壓過避險需求，金價回落',
        summary:
          '雖然中東局勢緊張帶來避險買盤，但市場擔心通脹令減息延後，拖累金價偏軟。',
        content:
          '分析指，油價上升可能推高通脹並削弱市場對短期減息的預期。即使避險情緒存在，高利率環境仍會降低持有黃金的吸引力。',
      },
      'zh-CN': {
        title: '通胀忧虑压过避险需求，金价回落',
        summary:
          '虽然中东局势紧张带来避险买盘，但市场担心通胀令降息延后，拖累金价偏软。',
        content:
          '分析指出，油价上升可能推高通胀并削弱市场对短期降息的预期。即使避险情绪存在，高利率环境仍会降低持有黄金的吸引力。',
      },
      en: {
        title: 'Gold slips as inflation fears outweigh safe-haven support',
        summary:
          'Higher energy prices and inflation concerns weighed on gold despite geopolitical uncertainty.',
        content:
          'Analysts said fears that inflation could stay elevated and delay rate cuts reduced gold’s appeal, even as safe-haven demand remained in the background.',
      },
    },
  },
  {
    id: 'gold-2026-03-16-trafigura-venezuela',
    slug: 'trafigura-venezuela-gold-march-16',
    category: 'gold',
    source: 'Reuters',
    publishedAt: '2026-03-16T12:00:00Z',
    image: '/img/news/gold-14.jpg',
    tags: ['Supply', 'Venezuela', 'Trafigura'],
    lang: {
      'zh-HK': {
        title: 'Trafigura 參與委內瑞拉黃金採購計劃，供應面受關注',
        summary:
          '商品交易商 Trafigura 與委內瑞拉國營黃金企業合作，市場關注供應鏈合規與國際銷售安排。',
        content:
          '該合作聚焦於建立較合規的黃金採購和銷售流程。對市場而言，這類消息反映實金供應來源與監管框架同樣會影響產業信心。',
      },
      'zh-CN': {
        title: 'Trafigura 参与委内瑞拉黄金采购计划，供应面受关注',
        summary:
          '大宗商品交易商 Trafigura 与委内瑞拉国营黄金企业合作，市场关注供应链合规与国际销售安排。',
        content:
          '该合作聚焦于建立更合规的黄金采购和销售流程。对市场而言，这类消息反映实金供应来源与监管框架同样会影响产业信心。',
      },
      en: {
        title: 'Trafigura move in Venezuela spotlights gold supply governance',
        summary:
          'A new sourcing arrangement involving Venezuela drew attention to compliance and supply-chain standards in the bullion trade.',
        content:
          'For the market, the development underlines that gold pricing is not the only issue; sourcing transparency and regulatory acceptance also matter to participants.',
      },
    },
  },
  {
    id: 'gold-2026-03-13-weekly-fall',
    slug: 'gold-second-weekly-fall-march-13',
    category: 'gold',
    source: 'Reuters',
    publishedAt: '2026-03-13T12:00:00Z',
    image: '/img/news/gold-15.jpg',
    tags: ['Weekly Move', 'Dollar', 'Rates'],
    lang: {
      'zh-HK': {
        title: '金價連跌兩周，美元走強成主要壓力',
        summary:
          '金價錄得連續第二周下跌，美元偏強及減息預期降溫影響黃金表現。',
        content:
          '市場認為美國利率可能維持高位更久，令無息資產黃金受壓。同時，美元轉強亦提高海外買家的持金成本，限制金價反彈。',
      },
      'zh-CN': {
        title: '金价连跌两周，美元走强成主要压力',
        summary:
          '金价录得连续第二周下跌，美元偏强及降息预期降温影响黄金表现。',
        content:
          '市场认为美国利率可能维持高位更久，令无息资产黄金承压。同时，美元走强也提高海外买家的持金成本，限制金价反弹。',
      },
      en: {
        title: 'Gold heads for second straight weekly loss as dollar firms',
        summary:
          'A stronger U.S. dollar and fading rate-cut hopes pressured bullion for a second consecutive week.',
        content:
          'Gold came under pressure as investors reassessed the outlook for U.S. monetary easing. The stronger dollar also made gold more expensive for holders of other currencies.',
      },
    },
  },
  {
    id: 'gold-2026-03-13-dubai-flows',
    slug: 'gold-flows-dubai-march-13',
    category: 'logistics',
    source: 'Reuters',
    publishedAt: '2026-03-13T08:00:00Z',
    image: '/img/news/gold-16.jpg',
    tags: ['Logistics', 'Dubai', 'Physical Gold'],
    lang: {
      'zh-HK': {
        title: '迪拜部分航班恢復，黃金物流逐步重啟',
        summary:
          '作為重要黃金中轉地，迪拜航班逐步恢復，有助實金運輸回復，但成本仍偏高。',
        content:
          '由於黃金多以空運方式流通，航班受阻會直接影響供應鏈效率。雖然運輸正在恢復，但保險及地面物流成本仍高，實金需求地區的買賣差價亦受影響。',
      },
      'zh-CN': {
        title: '迪拜部分航班恢复，黄金物流逐步重启',
        summary:
          '作为重要黄金中转地，迪拜航班逐步恢复，有助实金运输回升，但成本仍偏高。',
        content:
          '由于黄金多以空运方式流通，航班受阻会直接影响供应链效率。虽然运输正在恢复，但保险及地面物流成本仍高，实金需求地区的买卖价差也受到影响。',
      },
      en: {
        title: 'Partial flight recovery in Dubai helps restart gold flows',
        summary:
          'A gradual return of flights from Dubai supported the movement of physical gold, though logistics costs remained elevated.',
        content:
          'Because bullion is commonly moved by air, disruptions in aviation quickly affect physical supply chains. Even with some recovery, insurance and transport costs stayed high.',
      },
    },
  },
  {
    id: 'gold-2026-03-12-strong-dollar',
    slug: 'gold-strong-dollar-march-12',
    category: 'markets',
    source: 'Reuters',
    publishedAt: '2026-03-12T12:00:00Z',
    image: '/img/news/gold-17.jpg',
    tags: ['Dollar', 'Inflation', 'Gold'],
    lang: {
      'zh-HK': {
        title: '強美元與減息預期降溫，金價跌逾1%',
        summary:
          '美元走強及借貸成本預期維持高位，令金價受壓，單日跌幅超過1%。',
        content:
          '市場焦點集中於通脹風險與利率前景，黃金短線失去部分上升動力。當債息和美元同步偏強時，黃金通常較難維持強勢。',
      },
      'zh-CN': {
        title: '强美元与降息预期降温，金价跌逾1%',
        summary:
          '美元走强及借贷成本预期维持高位，令金价承压，单日跌幅超过1%。',
        content:
          '市场焦点集中于通胀风险与利率前景，黄金短线失去部分上行动力。当债息和美元同步偏强时，黄金通常较难维持强势。',
      },
      en: {
        title: 'Gold drops more than 1% on firm dollar and weaker rate-cut hopes',
        summary:
          'Bullion fell sharply as the dollar strengthened and markets pushed back expectations for lower borrowing costs.',
        content:
          'Rising inflation concerns and a stronger dollar reduced support for gold, highlighting how sensitive bullion remains to shifts in U.S. monetary expectations.',
      },
    },
  },
  {
    id: 'gold-2026-03-11-poland-reserves',
    slug: 'poland-gold-reserves-march-11',
    category: 'central-bank',
    source: 'Reuters',
    publishedAt: '2026-03-11T12:00:00Z',
    image: '/img/news/gold-18.jpg',
    tags: ['Central Bank', 'Reserves', 'Poland'],
    lang: {
      'zh-HK': {
        title: '波蘭央行談黃金儲備盈利用途，引發市場關注',
        summary:
          '波蘭央行提到可考慮運用黃金儲備的未實現收益，引起市場對官方黃金資產價值的關注。',
        content:
          '在金價高企背景下，央行持有黃金的帳面收益顯著上升。市場普遍視此為反映黃金在主權資產配置中地位提升的另一個訊號。',
      },
      'zh-CN': {
        title: '波兰央行谈黄金储备盈利用途，引发市场关注',
        summary:
          '波兰央行提到可考虑运用黄金储备的未实现收益，引起市场对官方黄金资产价值的关注。',
        content:
          '在金价高企背景下，央行持有黄金的账面收益显著上升。市场普遍视此为反映黄金在主权资产配置中地位提升的另一个信号。',
      },
      en: {
        title: 'Poland central bank comments draw attention to value of gold reserves',
        summary:
          'Remarks on potential use of profits linked to gold reserves highlighted the growing importance of official bullion holdings.',
        content:
          'With gold prices elevated, the unrealised gains on central bank reserves have become more visible, reinforcing the role of bullion in sovereign asset allocation.',
      },
    },
  },
  {
    id: 'gold-2026-01-29-record-demand',
    slug: 'global-gold-demand-record-2025',
    category: 'central-bank',
    source: 'Reuters / WGC',
    publishedAt: '2026-01-29T12:00:00Z',
    image: '/img/news/gold-19.jpg',
    tags: ['WGC', 'Demand', 'ETF'],
    lang: {
      'zh-HK': {
        title: '世界黃金協會：2025 年全球黃金需求創新高',
        summary:
          '世界黃金協會表示，2025 年全球黃金需求達歷史新高，投資需求和 ETF 資金流入成主要動力。',
        content:
          '儘管高金價打擊部分珠寶消費，但避險、資產配置及 ETF 投資需求仍大幅增加。數據反映黃金在高不確定環境下，仍被視為重要配置工具。',
      },
      'zh-CN': {
        title: '世界黄金协会：2025 年全球黄金需求创新高',
        summary:
          '世界黄金协会表示，2025 年全球黄金需求达历史新高，投资需求和 ETF 资金流入成为主要动力。',
        content:
          '尽管高金价打击部分珠宝消费，但避险、资产配置及 ETF 投资需求仍大幅增加。数据反映黄金在高不确定环境下，仍被视为重要配置工具。',
      },
      en: {
        title: 'World Gold Council says 2025 demand hit a record high',
        summary:
          'Global gold demand reached a record in 2025, driven by strong investment flows and safe-haven positioning.',
        content:
          'Even as higher prices weighed on jewellery consumption, ETF inflows and broader investment demand pushed total gold demand to a new high, underscoring bullion’s role in uncertain markets.',
      },
    },
  },
  {
    id: 'gold-2026-01-26-break-5100',
    slug: 'gold-breaks-5100-january-26',
    category: 'gold',
    source: 'Reuters',
    publishedAt: '2026-01-26T12:00:00Z',
    image: '/img/news/gold-20.jpg',
    tags: ['Record High', 'Safe Haven', 'Gold'],
    lang: {
      'zh-HK': {
        title: '金價年初曾升穿 5,100 美元，避險資金湧入',
        summary:
          '受地緣政治與宏觀不確定性帶動，金價於 1 月底創出歷史高位。',
        content:
          '市場當時對全球局勢、資產配置及央行買盤前景保持樂觀，令金價一度急升。此後走勢轉為反覆，但高位紀錄仍顯示資金對黃金的偏好明顯提升。',
      },
      'zh-CN': {
        title: '金价年初曾升穿 5,100 美元，避险资金涌入',
        summary:
          '受地缘政治与宏观不确定性带动，金价于 1 月底创出历史高位。',
        content:
          '市场当时对全球局势、资产配置及央行买盘前景保持乐观，令金价一度急升。其后走势转为反复，但高位纪录仍显示资金对黄金的偏好明显提升。',
      },
      en: {
        title: 'Gold surged above $5,100 earlier this year on safe-haven demand',
        summary:
          'Bullion hit record highs in late January as geopolitical concerns and allocation demand fueled buying.',
        content:
          'The move showed how quickly capital can rotate into gold when investors seek protection from macro and geopolitical uncertainty.',
      },
    },
  },
];